/* @flow */
import React, { Component } from 'react';
import ReactTooltip from 'react-tooltip';
import upperFirst from 'lodash/upperFirst';

import i18n from '../../../../i18n/i18n.js';

type Props = {
    selectedFee: {
        amount: number,
        currency: string,
        access_type: {
            period: string,
        },
        setup_fee: {
            amount: number,
            description: string,
            fee_amount: number,
        },
        trial_period: {
            quantity: number,
            period: string,
        },
    },
    lng: string,
    title: string,
};

export default class PaymentInfo extends Component<Props> {
    renderErrorMessage = (message: string) => {
        return (
            <p
                style={{
                    border: '0.5px solid #e8522d',
                    padding: '5px',
                }}
                className="inplayer-form-error "
            >
                <span className={`ipic_warning notif-icon`} />
                PayPal payment method does not currently support {message}.
            </p>
        );
    };

    render() {
        const { lng, selectedFee } = this.props;

        return (
            <span>
                {this.props.paymentMethod === 'paypal' &&
                    this.props.subSetupFee &&
                    this.renderErrorMessage(
                        'subscriptions with an additional setup fee'
                    )}
                {this.props.paymentMethod === 'paypal' &&
                    this.props.subFreeFullVoucher &&
                    this.renderErrorMessage(
                        'subscriptions with free trial period and 100% voucher'
                    )}
                {this.props.paymentMethod === 'paypal' &&
                    this.props.ppvfullVoucher &&
                    this.renderErrorMessage('ppv with 100% voucher')}
                <p>
                    I am paying for:&nbsp;
                    <strong> {this.props.title}</strong>
                </p>
                <p>
                    {i18n.t('payment_price', { lng })}:
                    <strong>
                        {' '}
                        {`${this.props.selectedFee.amount} ${
                            this.props.selectedFee.currency
                        }`}
                        {selectedFee.access_type.name === 'subscription' &&
                            ` / ${this.props.selectedFee.access_type.period}`}
                    </strong>
                </p>
                {this.props.selectedFee.setup_fee && [
                    <p key={0}>
                        <span
                            data-for="setup-fee"
                            data-tip={`
                            By purchasing this premium content you will be charged an additional<br />
                            one-time fee in the amount of ${
                                this.props.selectedFee.setup_fee.fee_amount
                            } ${this.props.selectedFee.currency}.<br />
                            This additional amount will be charged even if the subscription has a free-trial period.
                          `}
                        >
                            <span className="ipic_info" />
                            {upperFirst(
                                this.props.selectedFee.setup_fee.description
                            )}
                            :
                        </span>
                        &nbsp;
                        <strong>
                            {' '}
                            {`${this.props.selectedFee.setup_fee.fee_amount} ${
                                this.props.selectedFee.currency
                            }`}
                        </strong>
                    </p>,
                    <ReactTooltip key={1} id="setup-fee" html={true} />,
                ]}

                {this.props.selectedFee.trial_period && [
                    <p key={0}>
                        <strong
                            data-for="trial"
                            data-tip={`Paying for this asset will create subscription with ${
                                this.props.selectedFee.trial_period.quantity
                            }
                            ${
                                this.props.selectedFee.trial_period.period
                            } free trial. <br />
                            You will be charged ${
                                this.props.selectedFee.amount
                            } ${this.props.selectedFee.currency}
                            after the free trial expires.<br /> You can always cancel you subscription before the free trial period ends.`}
                        >
                            <span className="ipic_info" />
                            {`${this.props.selectedFee.trial_period.quantity} ${
                                this.props.selectedFee.trial_period.period
                            } free`}
                        </strong>
                    </p>,
                    <ReactTooltip key={1} id="trial" html={true} />,
                ]}
            </span>
        );
    }
}



// WEBPACK FOOTER //
// ./src/ui/components/Forms/Payments/PaymentInfo.js